import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import { TransitionExpand } from './../../animations';

const SearchFlyout = {
	name: 'SearchFlyout',
	props: {
		isOpened: {
			type: Boolean,
			required: true,
		},
		suggestionsApiEndpoint: {
			type: String,
			required: true,
		},
		resultPageUrl: {
			type: String,
			required: true,
		},
	},
	components: {
		TransitionExpand,
	},
  template: `
  	<div :class="{ 'search-flyout': true, 'search-flyout--opened': isOpened }">
			<div class="search-flyout__holder">
				<div class="search-flyout__form">
					<input type="text" @input="debounceInput" ref="searchInput" v-model="term" v-on:keyup.enter="search" placeholder="Search" />
				</div>
				<transition-expand>
					<div class="search-flyout__suggestions" v-if="suggestions.length > 0">
						<div class="search-flyout__suggestions-result">
							<ul>
								<li v-for="suggestion in suggestions" @click="changeTermFromSuggestion(suggestion)" v-html="suggestion.html"></li>
							</ul>
						</div>
					</div>
				</transition-expand>
			</div>
		</div>
  `,
  data: function(){
	return {
		term: '',
		suggestions: [],
	}
  },
  methods: {
	  search: function() {
		  if(this.term.length == 0)
			  return;		  
		  window.location.href = `${this.resultPageUrl}${this.term}`;
	  },
	  getSuggestions: function() {


	  superagent.post(this.suggestionsApiEndpoint).send({
	        term: this.term,
		}).set('accept', 'application/json').end((err, res) => {
	        if(err) {
	          return;
	        }

			this.suggestions = res.body.map(item => {
			  return {
				  value: item,
				  html: item,
			  };
			});

			this.suggestions = this.suggestions.map(suggestion => {
			  let reg = new RegExp(this.term, 'gi');
			  const matchedTerm = suggestion.value.match(reg);
			  if(matchedTerm && matchedTerm.length > 0) {
				  const html = suggestion.value;
				  suggestion.html = html.replace(matchedTerm[0], `<strong>${matchedTerm[0]}</strong>`);
			  }
			  return suggestion;
			});

	      });
	  },
	  changeTermFromSuggestion: function(suggestion) {
		  this.term = suggestion.value;
		  this.suggestions = [];
		  this.$refs.searchInput.focus();
	  },
	  debounceInput: _.debounce(function (e) {
		    this.term = e.target.value;
			if(this.term.length == 0) {
				this.suggestions = [];
				return;
			}
			this.getSuggestions();
		}, 100),
	},
	watch: {
		isSearchOpened: function(isOpened) {
			if(!isOpened) {
				this.term = [];
				this.suggestions = [];
			} else {
				this.$refs.searchInput.focus();
			}
		}
	},
	computed: {
      ...mapGetters({
				isSearchOpened: 'search/isOpened'
      })
    },
};

export default SearchFlyout;



// WEBPACK FOOTER //
// ../shared/components/search/search-flyout.js